import UiUserAvatar from '@/components/UiUserAvatar.vue'
import UiLink from '@/components/UiLink.vue'
import RowActionsPopover from './rowActions/RowActionsPopover.vue'
import getFullName from '@/utils/getFullName.js'
import getValue from '@/components/table/helpers/getValue'

export default {
  data() {
    return {
      columns: [
        {
          field: 'profile_photo_path',
          title: ' ',
          disallowChangeVisible: true,
          align: 'left',
          width: 50,
          key: 'photo',
          renderBodyCell: ({ row }, h) => {
            return <UiUserAvatar size="20px" src={row.profile_photo_path} rounded />
          },
        },
        {
          field: 'name',
          title: 'Имя',
          align: 'left',
          key: 'name',
          renderBodyCell: ({ row }, h) => {
            return (
              <div style="min-width: 130px">
                <UiLink to={{ name: 'manager-edit', params: { id: row.id } }}>
                  {' '}
                  {getFullName(row)}{' '}
                </UiLink>
              </div>
            )
          },
        },
        {
          field: 'position',
          title: 'Должность',
          key: 'position',
          align: 'left',
          renderBodyCell: ({ row }) => getValue(row, 'position'),
        },
        {
          field: 'email',
          title: 'Почта',
          align: 'left',
          key: 'email',
          renderBodyCell: ({ row }) => getValue(row, 'email'),
        },
        {
          field: 'phone',
          title: 'Телефон',
          align: 'left',
          key: 'phone',
          renderBodyCell: ({ row }) => getValue(row, 'phone'),
        },
        {
          field: 'actions',
          title: 'Действия',
          align: 'right',
          key: 'actions',
          width: 50,
          renderBodyCell: ({ row }, h) => {
            return <RowActionsPopover row={row} />
          },
        },
      ],
    }
  },
}
